import { Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environments/environment.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  navigationItems = [
    {
      absoluteUrl: this.env.FIELD_ADVICE_URL,
      label: 'adviceOverview',
      icon: 'dashboard',
    },
    {
      relativeUrl: '/',
      label: 'title',
      icon: 'dashboard',
    },
  ];
}
